module.exports = __webpack_public_path__ + "img/kjtb.2bcc1de7.png";